// extracted by mini-css-extract-plugin
export default {"introWrapper":"IntroScreen_introWrapper__u+uzD","imageContainer":"IntroScreen_imageContainer__wlmaQ","close":"IntroScreen_close__AtVCi"};